import React from 'react';

import { useIsShoppingBagRevampUX } from './MemberCreditsCartToggle';

interface ComponentProps {
  isShoppingBagRevampUX?: boolean;

  [key: string]: any;
}

export function withShoppingBagRevampUX(
  WrappedComponent: React.ComponentType<ComponentProps>
) {
  return function MemberCreditsStyleWrapper(props: ComponentProps) {
    const isShoppingBagRevampUX = useIsShoppingBagRevampUX();

    return (
      <WrappedComponent
        {...props}
        isShoppingBagRevampUX={isShoppingBagRevampUX}
      />
    );
  };
}
